module.exports = require("././dist/angular-disable-all.js");


//////////////////
// WEBPACK FOOTER
// angular-disable-all (bower component)
// module id = 1467
// module chunks = 0